module.exports = __webpack_public_path__ + "img/other2.71b3390d.png";